import MenuItemCarousel from "./MenuItemCarousel";

export default MenuItemCarousel;
